// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* theme color */\n[data-v-05d1b04e] .el-scrollbar__wrap {\n  overflow-y: hidden;\n  overflow-x: hidden;\n  width: 100%;\n  margin: 0 !important;\n}\n.layout-head-nav[data-v-05d1b04e] {\n  width: 100%;\n  background-color: #444;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
